/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import { Meta } from '@storybook/react/types-6-0'
import spotifyIcon from 'Shared/img/svg/spotify.svg'
import tiktokIcon from 'Shared/img/svg/tiktok.svg'
import closeIcon from 'Shared/img/svg/close.svg'
import buttonClose from 'Shared/img/svg/buttonClose.svg'
import checkMarkIcon from 'Shared/img/svg/checkmark.svg'
import checkMarkIconWhite from 'Shared/img/svg/checkmark-white.svg'
import arrowIcon from 'Shared/img/svg/arrow.svg'
import GoogleIcon from 'Shared/img/google.png'
import FacebookIcon from 'Shared/img/facebook.png'
import GreenAlert from 'Shared/img/svg/greenAlert.svg'
import OrangeAlert from 'Shared/img/svg/orangeAlert.svg'
import redAlert from 'Shared/img/svg/redAlert.svg'
import protection from 'Shared/img/svg/protection.svg'
import LockIcon from 'Shared/img/lock.svg'
import ArrowTotalDown from 'Shared/img/svg/arrowTotalDown.svg'
import ArrowTotalUp from 'Shared/img/svg/arrowTotalUp.svg'
import Visa from 'Shared/img/svg/visa.svg'
import MasterCard from 'Shared/img/svg/masterCard.svg'
import Discover from 'Shared/img/svg/discover.svg'
import JCB from 'Shared/img/svg/jcb.svg'
import DinersClub from 'Shared/img/svg/dinersClub.svg'
import PayPal from 'Shared/img/svg/paypal.svg'
import DefaultCover from 'Shared/img/svg/defaultCover.svg'
import Successfully from 'Shared/img/svg/successfully.svg'
import questionMark from 'Shared/img/svg/questionMark.svg'
import errorAlertIcon from 'Shared/img/svg/errorAlertIcon.svg'
import PartyPopper from 'Shared/icons/party-popper.png'
import LiveChat from 'Shared/img/svg/liveChat.svg'
import ShareFeedback from 'Shared/img/svg/shareFeedback.svg'
import Bug from 'Shared/img/svg/bug.svg'
import Campaigns from 'Shared/img/svg/campaigns.svg'
import Settings from 'Shared/img/svg/settings.svg'
import HelpCenter from 'Shared/img/svg/helpCenter.svg'
import Balance from 'Shared/img/svg/balance.svg'
import Reviews from 'Shared/img/svg/reviews.svg'
import Feed from 'Shared/img/svg/feed.svg'
import Rank from 'Shared/img/svg/rank.svg'
import Playlists from 'Shared/img/svg/playlists.svg'
import Analitics from 'Shared/img/svg/analitics.svg'
import AdminPanel from 'Shared/img/svg/adminPanel.svg'
import UsersSideBar from 'Shared/img/svg/usersSideBar.svg'
import Logout from 'Shared/img/svg/logout.svg'
import Chart from 'Shared/img/svg/chart.svg'
import WarningSign from 'Shared/img/svg/warning-sign.svg'
import StarYellow from 'Shared/img/svg/star-yellow.svg'
import StarGrey from 'Shared/img/svg/star-grey.svg'
import HeartGrey from 'Shared/img/svg/heart-grey.svg'
import AngryFaceGrey from 'Shared/img/svg/angry-face-grey.svg'
import DislikeGrey from 'Shared/img/svg/dislike-grey.svg'
import ChristmasToy from 'Shared/icons/christmas-toy.svg'
import CheckInfluencer from 'Shared/img/svg/checkInfluencer.svg'
import ModalClose from 'Shared/img/svg/modalClose.svg'
import Rubbish from 'Shared/img/svg/rubbish.svg'
import Refresh from 'Shared/img/svg/refresh.svg'
import Search from 'Shared/img/svg/search.svg'
import Plus from 'Shared/img/svg/plus.svg'
import PlusWhite from 'Shared/img/svg/plusWhite.svg'
import Play from 'Shared/img/svg/play.svg'
import Pause from 'Shared/img/svg/pause.svg'
import Tracks from 'Shared/img/svg/tracks.svg'
import TikTokWhite from 'Shared/img/svg/tiktokWhite.svg'
import CurlLink from 'Shared/img/svg/curlLink.svg'
import WarningNoData from 'Shared/img/svg/warningNoData.svg'

import { IconStorybook } from './Icon'
import Center from '../Center/Center'

import * as S from './Icon.styled'

export default {
  title: 'Icons/Icons',
  component: IconStorybook,
  decorators: [story => <Center>{story()}</Center>],
} as Meta

export const PauseIcon = (): JSX.Element => <img src={Pause} alt="Pause Icon" />

export const PlayIcon = (): JSX.Element => <img src={Play} alt="Play Icon" />

export const IconSpotify = (): JSX.Element => (
  <img src={spotifyIcon} alt="Spotify Icon" />
)

export const IconTikTok = (): JSX.Element => (
  <img src={tiktokIcon} alt="TikTok Icon" />
)

export const IconClose = (): JSX.Element => (
  <img src={closeIcon} width={10} height={10} alt="Close Icon" />
)
export const IconQuestionMark = (): JSX.Element => (
  <img src={questionMark} width={7} height={14} alt="Question Icon" />
)

export const ButtonClose = (): JSX.Element => (
  <img src={buttonClose} width={10} height={10} alt="Button Close" />
)

export const IconCheckMark = (): JSX.Element => (
  <img src={checkMarkIcon} alt="CheckMark Icon" />
)

export const IconCheckMarkWhite = (): JSX.Element => (
  <img src={checkMarkIconWhite} alt="CheckMark Icon" />
)

export const IconArrow = (): JSX.Element => (
  <img src={arrowIcon} alt="Arrow Icon" />
)

export const IconGoogle = (): JSX.Element => (
  <img src={GoogleIcon} alt="Google Icon" />
)

export const IconFacebook = (): JSX.Element => (
  <img src={FacebookIcon} alt="Facebook Icon" />
)

export const IconCreenAlert = (): JSX.Element => (
  <img src={GreenAlert} alt="Icon Info" />
)

export const IconOrangeAlert = (): JSX.Element => (
  <img src={OrangeAlert} alt="Icon Info" width={16} height={13} />
)

export const IconRedAlert = (): JSX.Element => (
  <img src={redAlert} alt="Icon Info" />
)

export const IconProtection = (): JSX.Element => (
  <img src={protection} width={21} height={24} alt="Icon Protection" />
)

export const IconLock = (): JSX.Element => (
  <img src={LockIcon} width={21} height={24} alt="Icon LockIcon" />
)

export const IconLockMobile = (): JSX.Element => (
  <img src={LockIcon} width={18.14} height={24} alt="Icon LockIcon" />
)

export const ArrowTotalBtnDown = () => (
  <img src={ArrowTotalDown} width={6} height={12} alt="Icon ArrowTotal" />
)

export const ArrowTotalBtnUp = (): JSX.Element => (
  <img src={ArrowTotalUp} width={6} height={12} alt="Icon ArrowTotal Up" />
)

export const IconVisa = (): JSX.Element => (
  <img src={Visa} width={32} height={10} alt="Visa" />
)

export const IconMasterCard = (): JSX.Element => (
  <img src={MasterCard} width={26} height={16} alt="MasterCard" />
)

export const IconDiscover = (): JSX.Element => (
  <img src={Discover} width={32} height={10} alt="Discover" />
)

export const IconJCB = (): JSX.Element => (
  <img src={JCB} width={22} height={16} alt="JCB" />
)

export const IconDinersClub = (): JSX.Element => (
  <img src={DinersClub} width={24} height={16} alt="DinersClub" />
)

export const IconPayPal = (): JSX.Element => (
  <img src={PayPal} width={150} height={40} alt="Paypal" />
)

export const IconDefaultCover = (): JSX.Element => (
  <img src={DefaultCover} width={12} height={16} alt="DefaultCover" />
)

export const IconSuccessfully = (): JSX.Element => (
  <img src={Successfully} width={48} height={48} alt="Successfully" />
)

export const IconPartyPopper = (): JSX.Element => (
  <img src={PartyPopper} width={16} height={16} alt="PartyPopper" />
)

export const IconErrorAlert = (): JSX.Element => (
  <img src={errorAlertIcon} width={16} height={14.14} alt="ErrorAlert" />
)

export const IconLiveChat = (): JSX.Element => (
  <img src={LiveChat} width={16} height={16} alt="IconLiveChat" />
)

export const IconShareFeedback = (): JSX.Element => (
  <img src={ShareFeedback} width={16} height={16} alt="IconShareFeedback" />
)

export const IconBug = (): JSX.Element => (
  <img src={Bug} width={16} height={16} alt="IconBug" />
)

export const IconCampaigns = (): JSX.Element => (
  <img src={Campaigns} width={16} height={16} alt="Campaigns" />
)

export const IconSettings = (): JSX.Element => (
  <img src={Settings} width={16} height={16} alt="Settings" />
)

export const IconHelpCenter = (): JSX.Element => (
  <img src={HelpCenter} width={16} height={16} alt="HelpCenter" />
)

export const IconBalance = (): JSX.Element => (
  <img src={Balance} width={16} height={16} alt="Balance" />
)

export const IconReviews = (): JSX.Element => (
  <img src={Reviews} width={16} height={16} alt="Reviews" />
)

export const IconFeed = (): JSX.Element => (
  <img src={Feed} width={16} height={16} alt="Feed" />
)

export const IconRank = (): JSX.Element => (
  <img src={Rank} width={16} height={16} alt="Rank" />
)

export const IconPlaylists = (): JSX.Element => (
  <img src={Playlists} width={16} height={16} alt="Playlists" />
)

export const IconAnalitics = (): JSX.Element => (
  <img src={Analitics} width={16} height={16} alt="Analitics" />
)

export const IconAdminPanel = (): JSX.Element => (
  <img src={AdminPanel} width={16} height={16} alt="AdminPanel" />
)

export const IconUsersSideBar = (): JSX.Element => (
  <img src={UsersSideBar} width={16} height={16} alt="UsersSideBar" />
)

export const IconLogout = (): JSX.Element => (
  <img src={Logout} width={16} height={16} alt="Logout" />
)

export const ChartIcon = (): JSX.Element => (
  <img src={Chart} width={16} height={16} alt="Chart" />
)

export const WarningSignIcon = () => (
  <img src={WarningSign} width={16} height={16} alt="WarningSign" />
)

export const StarYellowIcon = () => (
  <img src={StarYellow} width={12} height={12} alt="StarYellow" />
)

export const StarGreyIcon = () => (
  <img src={StarGrey} width={12} height={12} alt="StarGrey" />
)

export const HeartGreyIcon = () => (
  <img src={HeartGrey} width={16} height={16} alt="HeartGrey" />
)

export const AngryFaceGreyIcon = () => (
  <img src={AngryFaceGrey} width={16} height={16} alt="AngryFaceGrey" />
)

export const DislikeGreyIcon = () => (
  <img src={DislikeGrey} width={16} height={16} alt="DislikeGrey" />
)

export const ChristmasToyIcon = () => (
  <S.ChristmasToyStyled src={ChristmasToy} alt="ChristmasToy" />
)

export const CheckInfluencerIcon = () => (
  <img src={CheckInfluencer} width={16} height={10} alt="Check" />
)
export const ModalCloseIcon = () => (
  <img src={ModalClose} width={10} height={10} alt="Close" />
)

export const RubbishIcon = () => (
  <img src={Rubbish} width={16} height={16} alt="Close" />
)

export const RefreshIcon = () => (
  <img src={Refresh} width={16} height={16} alt="Refresh" />
)

export const SearchIcon = () => (
  <img src={Search} width={16} height={16} alt="Search" />
)

export const PlusIcon = () => (
  <img src={Plus} width={11} height={11} alt="Plus" />
)

export const PlusIconWhite = () => (
  <img src={PlusWhite} width={11} height={11} alt="Plus" />
)

export const TracksIcon = () => (
  <img src={Tracks} width={16} height={16} alt="Tracks" />
)

export const TikTokWhiteIcon = () => (
  <img src={TikTokWhite} width={13.47} height={15.96} alt="TikTokWhite" />
)

export const CurlLinkIcon = () => (
  <img src={CurlLink} width={15} height={16} alt="CurlLink" />
)
/* <object
type="image/svg+xml"
data="Shared/img/svg/search.svg"
width="16"
height="16"
>
<img src="Shared/img/svg/search.svg" width="16" height="16" alt="search" />
</object> */

export const WarningNoDataIcon = () => (
  <img src={WarningNoData} width={16} height={14.14} alt="WarningNoData" />
)
